import firebase from 'firebase/app';
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = require('../../../config/firebase.' + process.env.NODE_ENV)

firebase.initializeApp(firebaseConfig)

export const db = firebase.firestore()
db.settings({ timestampsInSnapshots: true })

export const storage = firebase.storage()

export const login = async function() {
  const { user } = await firebase.auth().signInAnonymously()
  await db.collection('rooms').doc(user.uid).set({}, { merge: true }) // init my room
  // await userDoc.set({
  //   displayName: user.displayName,
  //   timestamp: timestamp(),
  //   roomId,
  //   roomToken
  // }, { merge: true })
  // const userRef = await userDoc.get()
  return user
}

export function timestamp() {
  return firebase.firestore.FieldValue.serverTimestamp()
}

timestamp.fromMillis = firebase.firestore.Timestamp.fromMillis